import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

const slug = v => v.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+/, "").slice(0, 40);

export const LessonManager = ({ api, selected, onCreated, onDeleted }) => {
  const [title, setTitle] = useState("");
  const [id, setId] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState("");
  const create = async e => {
    e.preventDefault(); setError("");
    try { const r = await api("post", "/admin/lessons", { id: id.replace(/-+$/, ""), title }); setTitle(""); setId(""); onCreated(r.data); }
    catch (err) { const d = err.response?.data?.detail; setError(Array.isArray(d) ? "Use lowercase letters, numbers and dashes for the id" : d || "Could not create lesson"); }
  };
  const remove = async () => { if (!confirm) return setConfirm(true); setConfirm(false); await api("delete", `/admin/lessons/${selected}`); onDeleted(selected); };
  return <div className="lesson-manager" data-testid="lesson-manager">
    <form className="new-lesson" onSubmit={create}>
      <input required value={title} onChange={e => { setTitle(e.target.value); setId(slug(e.target.value).replace(/-+$/, "")); }} placeholder="New lesson title" data-testid="new-lesson-title"/>
      <input required value={id} onChange={e => setId(slug(e.target.value))} placeholder="url-id" data-testid="new-lesson-id"/>
      <button className="filter" type="submit" data-testid="new-lesson-create-button"><Plus size={12}/> CREATE</button>
    </form>
    {selected && <button className={confirm ? "filter danger armed" : "filter danger"} onClick={remove} onBlur={() => setConfirm(false)} data-testid="delete-lesson-button"><Trash2 size={12}/> {confirm ? "CLICK AGAIN TO DELETE" : "DELETE LESSON"}</button>}
    {error && <div className="form-error" data-testid="lesson-manager-error">{error}</div>}
  </div>;
};
